'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './workorders-code-edit.routes';

export class WorkOrderCodeEditComponent {
  constructor(Auth, $state, $stateParams, dialogs, WorkOrderCodesService, TemplateService, $uibModal) {
    'ngInject';

    this.codeId = $stateParams.id;

    this.dialogs = dialogs;
    this.WorkOrderCodesService = WorkOrderCodesService;
    this.TemplateService = TemplateService;
    this.Auth = Auth;
    this.$uibModal = $uibModal;

    this.jsonValue = "";
    this.$state = $state;

    this.allowedFileTypes = [{
      mime: '',
      name: 'All Files'
    }, {
      mime: 'image/*',
      name: "Images"
    }, {
      mime: 'application/pdf',
      name: "PDF Documents"
    }];

    this.toolbarDefinition = [
      ["bold","italics","underline"],
      ["h3","h4","h5"],
      ["p","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["undo","redo"]/*,
      ["backgroundColor","fontColor","fontName", "fontSize"]*/
    ];

    this.templates = [];

    this.TemplateService.query(data => {
      this.templates = data;
    });

    this.model = {
    };

    if (this.codeId) {
      this.WorkOrderCodesService.get({id: this.codeId}, data => {
        this.model = data;
        this.recipients = !data.recipients ? '' : data.recipients.join("\n");
      }, err => {
        console.log('Could not load work order code from server');
      })
    }

  }

  templateLookup(idx) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'templateLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (template) {
        that.model.template = template._id;
      },
      function () { /* cancel */ }
    );

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.codeId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The work order code has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("workorder-code-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      var lines = this.recipients.split(/\n/);
      this.model.recipients = [];
      for (let i=0; i < lines.length; i++) {
        // only push this line if it contains a non whitespace character.
        if (/\S/.test(lines[i])) {
          this.model.recipients.push(lines[i].trim());
        }
      }

      if (this.codeId) {  // Save changes on the current settings
        this.WorkOrderCodesService.update({id: this.codeId}, this.model, onSuccess, onError);
      } else { // Create new settings
        this.model.meta = {creationUser: this.Auth.getCurrentUserSync()._id};
        this.WorkOrderCodesService.save(this.model, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.workOrderCodeEdit', [uiRouter])
  .config(routes)
  .component('workOrderCodeEdit', {
    template: require('./workorders-code-edit.html'),
    controller: WorkOrderCodeEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/workorders/code-edit/workorders-code-edit.component.js